import { Identity_Platform } from 'constants/identityPlatforms'

export const getUserIdentityPlatform = (isInternalUser: string) => {
  return isInternalUser == 'true' ? Identity_Platform.AAD : Identity_Platform.CIP
}
